<template>
<div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base examItem">
  <vx-card class="text-center" style="height:180px;" v-if="examInfo" scrollHeight>
    <div class="text-center">
      <div class="vx-row justify-end" style="max-height:300px;">
        <div style="width: 100%;">
          <div style="position:absolute; width:45px; height:20px; top:5px; padding:1px 0; font-size:12px; font-weight:bold; border-radius:40px; background:#ffe998" v-if="this.examInfo.info == 'sat'">
            <p>수능</p>
          </div>
          <div style="position:absolute; width:45px; height:20px; top:5px; padding:1px 0; font-size:12px; font-weight:bold; border-radius:40px; background:#ffe998"
               v-if="this.examInfo.info == 'high' && this.examInfo.grade == 2">
            <p>고2</p>
          </div>
          <div style="position:absolute; width:45px; height:20px; top:5px; padding:1px 0; font-size:12px; font-weight:bold; border-radius:40px; background:#ffe998"
               v-if="this.examInfo.info == 'high' && this.examInfo.grade == 1">
            <p>고1</p>
          </div>
          <div class="state" style="margin-bottom:10px;">
            <button type="button" name="button" :class="{active : item.isActive}" v-for="(item, index) in button_state" :key="index" @click="changeState(item)">{{ item.state }}</button>
            <!-- <vs-switch color="success" v-model="serviceVal">
              <span slot="on">비승인</span>
              <span slot="off">승인</span>
            </vs-switch> -->
            <!-- <vs-switch v-if="type" color="success" v-model="testVal">
              <span slot="on">시작</span>
              <span slot="off">준비</span>
            </vs-switch> -->
          </div>
          <span style="">{{userID()}}</span>
          <!-- </div> -->
        </div>
        <div class="vx-row justify-end" style="width: 80%;">
          <!-- <div v-if='spaceInfo.level == 5' class="flspliltex items-center"  @click="workspacePopup =true">
              <vs-button class="flex items-center" style="margin:3px;" color="dark" type="flat" icon="icon-edit" icon-pack="feather" />
            </div>
            <div v-if='spaceInfo.level == 5' class="flex items-center" @click="workspaceDelete()">
              <vs-button class="flex items-center" style="margin:3px;" color="danger" type="flat" icon="icon-trash" icon-pack="feather" />
            </div> -->
        </div>
      </div>
      <vs-button class="w-full" color="primary" type="flat" style="font-size: 15px; width:15px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;" @click="showExam()"><strong>{{examInfo.test_name}}</strong></vs-button>
    </div>
    <div>
      <vs-divider style="margin-top:2px;" />
      <div class="flex justify-center flex-wrap" style="margin-top:10px;">
        <!-- <p style="margin-right:5px;"> {{subjectInfo.subject}} </p> &nbsp; -->
        <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-list" @click="showSubject()"></vs-button>
      </div>
    </div>
  </vx-card>
</div>
</template>


<script>
export default {
  props: ['examInfo', 'type'],
  data() {
    return {
      serviceVal: false,
      data_local: '',
      testVal: false,
      button_state: [
        {id: 0, state: '대기', isActive: false},
        {id: 1, state: '진행', isActive: false},
        {id: 2, state: '완료', isActive: false}
      ],
    }
  },
  watch: {
    // serviceVal() {
    //   console.log(this.serviceVal)
    //   // this.data_local.admin_check = this.serviceVal ? 0 : 1
    //   // // this.$store.dispatch('etest/updateExamState', {'id': this.data_local.id, 'state':this.data_local.state})
    //   // this.$store.dispatch('etest/updateAdminExamState', {
    //   //   'id': this.data_local.id,
    //   //   'admin_check': this.data_local.admin_check
    //   // })
    // },
    // testVal() {
    //   this.data_local.test_state = this.testVal ? 1 : 0
    //   // console.log(this.data_local.test_state)
    //   if (this.data_local.test_state == 1) {
    //     this.$store.dispatch('etest/updateAdminTestState', {
    //       'id': this.data_local.id,
    //       'test_state': this.data_local.test_state
    //     })
    //   }
    // }
  },
  computed: {

  },
  methods: {
    changeState(val) {
      console.log(this.examInfo)
      this.$emit('state' , {
        state : val.id,
        exam_id: this.examInfo.id
      })
    },
    userID() {
      return 'ID:' + this.examInfo.email.split('@')[0]
    },
    showExam() {
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/0')
    },
    showSubject() {
      this.$store.commit('etest/ACTIVE_EXAML', this.examInfo)
      this.$router.push('/apps/etest/editer/1')
    }
  },
  created() {
    if(!this.examInfo){
      return
    }
      this.button_state[this.examInfo.test_state].isActive = true
  }
}
</script>

<style>
.text {
  font-size: 14px;
  max-width: 400px;
  line-height: 1.5;
}
.examItem .state button{
  background-color: #fff;
  outline: none;
  color: #333;
  border: 1px solid #ddd;
  padding: 7px 10px;
  font-weight: bold;
  transition: 0.3s;
  cursor: pointer;
}
.examItem .state button:hover{
  background-color: #F9EFC9;
}
.examItem .state button:nth-child(1){
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.examItem .state button:nth-child(2){
  border-left: none;
  border-right: none;
}
.examItem .state button:nth-child(3){
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.examItem .state button.active{
  background-color: #ffe998;
}
</style>
